import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-footer-landing",
  imports: [SharedModule, TranslateModule, RouterModule],
  templateUrl: "./footer-landing.component.html",
  styleUrl: "./footer-landing.component.scss",
})
export class FooterLandingComponent {}
